export const MessageViewType = {
  Text: 'TEXT',
  Audio: 'AUDIO',
  Video: 'VIDEO',
} as const;
